import { isEqual } from 'lodash-es';

/** The fields of `next` whose values differ from `previous`, compared deeply. */
export const changedFields = <T extends object>(
  previous: T,
  next: T
): Partial<T> =>
  Object.fromEntries(
    Object.entries(next).filter(
      ([key, value]) => !isEqual(value, previous[key as keyof T])
    )
  ) as Partial<T>;
